exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span[data-v-0ffb562a]{cursor:pointer}", ""]);

// exports
